<template>
  <div class="col-sm-12 header-component mb16 flex-row" id="pageTop">
    <home-page-user-address :module-props="modulePropsData"></home-page-user-address>
    <reward-program
      v-if="Object.keys(modulePropsData).length" 
     :module-props="modulePropsData"></reward-program>
    <!-- Profile Icon -->
    <div>
      <div
        class="profile-icon flex-column"
        v-bind:style="{border: `1px solid ${modulePropsData?.themeColor}`}"
        @click="handleProfileIconClick($event)"
      >
        <span>
          <i 
            class="jfi-user-v2 fs-18"
            v-bind:style="{color: modulePropsData?.themeColor}"
          ></i></span>
      </div>
      <profile-drawer-modal
        v-if="showProfileDrawerModal || loadProfileDrawerModal"
        :data-left-menu-links="dataResults"
        :showProfileDrawerModal="showProfileDrawerModal"
        :edvType="modulePropsData?.edvType || '199'"
        @close-profile-modal="closeProfileModal()"
      ></profile-drawer-modal>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import HomePageUserAddress from "./HomePageUserAddress.vue";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import UserActivityTracking from "../helpers/UserActivityTracking";
import { keyMapsMutation} from "../helpers/storeKeys";

export default {
  name: "TopBar",
  components: {
    HomePageUserAddress,
    RewardProgram : defineAsyncComponent(() =>
      import("./RewardProgram.vue")
    ),
    ProfileDrawerModal: defineAsyncComponent(() =>
      import("./ProfileDrawerModal.vue")
    ),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      isOnStorePage: (window.location.href.search(Utility.storeRegex) > -1),
      showProfileDrawerModal: false,
      loadProfileDrawerModal: false,
      modulePropsData : {},
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    UserActivityTracking.pageView(0,"homePageView");
    setTimeout(() => {
      this.loadProfileDrawerModal = true;
    }, 10000);
    
    const placeHolderImg_sq = this.modulePropsData?.placeHolder_sq;
    const placeHolderImg_rect = this.modulePropsData?.placeHolder_rect;
    this.$store.commit(keyMapsMutation.UPDATE_PLACE_HOLDER_IMAGE, {
      square: placeHolderImg_sq,
      rect : placeHolderImg_rect
      }
    );
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      const isLogged = this.isLoggedIn ? "yes" : "no";
      let preEventObj = { category: "profile", loginStatus: isLogged, ...eObj };
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "topbar",
        "1",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    handleProfileIconClick() {
      //Amplitude click event load
      this.eventFunction(true);
      this.showProfileDrawerModal = true;
      //Amplitude impression event load
      this.eventFunction(false, { actionType: "hamburger menu" });
      UserActivityTracking.hamburgerMenuView(0);
    },
    closeProfileModal() {
      this.showProfileDrawerModal = false;
    },
  },
  computed: {
    isLoggedIn() {
      let _ = this.$store.state.Auth.isLoggedIn;
      this.links = JSON.parse(this.dataResults)?.filter((__) => {
        return !(!_ && __.name == "My Wallet");
      });
      return _;
    },
  },
};
</script>
